module.exports = __webpack_public_path__ + "img/qiu3.6dd8c81e.png";